/* eslint-disable */
export enum processingLocalisationKeys {
  PROCESSING_DATA = 'PROCESSING_DATA',
  PRESS_FINISH = 'PRESS_FINISH',
  FINISH = 'FINISH'
}

export const enProcessingLocalisationMessages = {
  [processingLocalisationKeys.PROCESSING_DATA]: `Thanks! We're processing your data now.`,
  [processingLocalisationKeys.PRESS_FINISH]: `This will happen in the background; press finish to continue.`,
  [processingLocalisationKeys.FINISH]: `Finish`
}
